import { BaseCloseButton } from "../base-close-button"
import type { HeaderBaseProps } from "../factory-header.types"
import { SiteHeader } from "../site-header"

export function SisalUploadDocHeader({ homePageLogoLink }: HeaderBaseProps) {
  return (
    <SiteHeader className="jumio-header">
      {homePageLogoLink}
      <BaseCloseButton />
    </SiteHeader>
  )
}
